module.exports = "https://cdn-assessment.mathletics.com/app/113/assets/images/27225403faa7cb949eeb6d1f3611edb7.gif";